import { render, staticRenderFns } from "./taskTable.vue?vue&type=template&id=1011db37&scoped=true&"
import script from "./taskTable.vue?vue&type=script&lang=js&"
export * from "./taskTable.vue?vue&type=script&lang=js&"
import style0 from "./taskTable.vue?vue&type=style&index=0&id=1011db37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011db37",
  null
  
)

export default component.exports